import React from "react";

const Spinner = () => {
  return (
    <div class="flex justify-center items-center">
      <div class="h-3 w-3 border-t-2 border-b-2 border-gray-900 rounded-full animate-spin"></div>
    </div>
  );
};

export default Spinner;
